import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { NgIf } from '@angular/common';
import { FormsModule, } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { UpdateAppService } from './update-app.service';
import { lastValueFrom } from 'rxjs';
import { AppInfos } from 'src/app/app.models';
import { AppService } from 'src/app/services/app.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';
import { invoke } from '@tauri-apps/api/core';
import { listen } from '@tauri-apps/api/event';
import { CluConfirmDialogService } from 'src/app/utils/clu-confirm-dialog/clu-confirm-dialog.service';

@Component({
  selector: 'app-update-app',
  standalone: true,
  imports: [RouterModule, MaterialModule, NgIf, FormsModule, ReactiveFormsModule],
  providers: [UpdateAppService],
  templateUrl: './update-app.component.html',
})
export class AppUpdateAppComponent implements OnInit {
    options = this.settings.getOptions();
    loading = false;
    errorText: string | null = null;
    appVersion: AppInfos;
    serverVersion: AppInfos;
    state: 'idle' | 'downloading' | 'downloaded' = 'idle';
    progress = 0;

  constructor(
    private settings: CoreService,
    private router: Router,
    private appService: AppService,
    private updateService: UpdateAppService,
    private tauriService: TauriService,
    private cluConfirmDialogService: CluConfirmDialogService
  ) {
    this.appVersion = this.appService.appVersion$.value;
    this.serverVersion = this.tauriService.appUpdateInfos;
  }

  ngOnInit(): void {
    listen('download-progress', (event) => {
      this.progress = parseFloat((event.payload as number).toFixed(2));
      this.state = 'downloading';
    });

    listen('download-complete', () => {
      console.log('Téléchargement terminé');
      this.state = 'downloaded';
    });
  }

  doInstallUpdatesAction() {
    invoke('download_latest_update', {
      url: 'https://res.leseditionscauris.com/cauris-linkup-workspace-app-7.0.0.msi',
      savePath: 'C:/ProgramData/CaurisLinkup/cauris-linkup-workspace-app-7.0.0.msi'
    });
    this.state = 'downloading';
  }

  async doCancelUpdatesAction() {
    const confirm = await this.cluConfirmDialogService.showConfirmDialog('Annuler la mise à jour', 'Êtes-vous sûr de vouloir annuler la mise à jour en cours ?');
    if (confirm) {
      invoke('cancel_download');
      this.state = 'idle';
      this.progress = 0;
    }
  }
}
